
import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { GoogleBigQueryV2LinkedService } from '../linkedservice/google-bigquery-v2.linkedservice';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { GoogleBigQueryV2Versions } from 'app/registries/linked-service/google-bigquery-v2-metadata';
import { GlobalVariables } from 'app/services/globals';
import { type IVersioningDataset } from 'shell-models-lib';
@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.googleBigQuery.datasetType : adfModelTypeMap.googleBigQueryV2.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.GoogleBigQuery_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.GoogleBigQuery_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: GoogleBigQueryV2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class GoogleBigQueryObjectV2Dataset extends TabularTypeDataset implements IVersioningDataset {
    public static readonly MODEL: IModel;
    public static VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        templatable: true,
        association: 'VERSION'
    })
    public version: string = GlobalVariables.enableGBQVersion && __IS_FABRIC_DPE__ ? GoogleBigQueryV2Versions.V1_1 : undefined;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
